import { render, staticRenderFns } from "./TopicsTree.vue?vue&type=template&id=780b33cc&scoped=true"
import script from "./TopicsTree.vue?vue&type=script&lang=js"
export * from "./TopicsTree.vue?vue&type=script&lang=js"
import style0 from "./TopicsTree.vue?vue&type=style&index=0&id=780b33cc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "780b33cc",
  null
  
)

export default component.exports